// An environment's VPN (D80): the VPN page and panel, the relay command, the task group's
// "Tasks require VPN" switch and its notes.
export default {
  title: "VPN",
  state: {
    absent: "No VPN",
    down: "Not connected",
    signing_in: "Waiting for sign-in",
    up: "Connected",
  },
  link: (state: string) => `VPN: ${state}`,
  loadFailed: "Could not load the VPN",
  settings: {
    title: "Profile",
    hint: "Upload your .ovpn on the Secrets page (type: VPN profile), then choose it here. DNS servers and domains are for names only the VPN can resolve, such as Jenkins or Kubernetes.",
    profile: "VPN profile",
    none: "No VPN",
    noProfiles: "You have no VPN profile secret yet.",
    addProfile: "Add one on the Secrets page",
    dnsServers: "DNS servers",
    dnsServersHint: "Comma-separated, e.g. 10.0.10.156",
    dnsDomains: "Domains for those servers",
    dnsDomainsHint: "Comma-separated, e.g. aws, svc.cluster.aws",
    save: "Save",
    saved: "VPN settings saved",
  },
  connect: {
    connect: "Connect VPN",
    again: "Sign in again",
    disconnect: "Disconnect",
    phoneHint: "Easier on your phone: in the OpenCloudSecurity app, open this environment and tap Connect VPN. The app signs you in and completes the connection, with no Terminal command.",
    step1: "1. On your computer, open Terminal and run this command. It waits for your sign-in and passes it to OpenCloudSecurity.",
    step2: "2. Sign in with your company account. When the page says you can close it, your environment's VPN connects.",
    signIn: "Sign in",
    copy: "Copy",
    copied: "Copied",
    alternative: "If that command does not work on your computer, use this one instead (needs Python 3):",
    expires: (time: string) => `This sign-in link works once, until ${time}.`,
    waiting: "Waiting for your sign-in…",
    connected: "VPN connected.",
    failed: (reason: string) => `The VPN did not connect: ${reason}`,
  },
  group: {
    requires: "Tasks require VPN",
    requiresHint: "Steps wait while your environment's VPN is down; you are notified with a link to connect.",
    requiredBadge: "Requires VPN",
    noProfile: "This group requires a VPN but your environment has none. Add a VPN profile.",
    waiting: "Steps are waiting for the VPN.",
    setUp: "Set up VPN",
  },
};
